import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_update_promotions_menu_identifier_settings: { message: "idle" },
};

export const tenant_update_promotions_menu_identifier_settings_Slice = createSlice({
 name: "tenant_update_promotions_menu_identifier_settings",
 initialState,
 reducers: {
  success_tenant_update_promotions_menu_identifier_settings: (state, action) => {
   state.tenant_update_promotions_menu_identifier_settings = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_update_promotions_menu_identifier_settings: (state, action) => {
   state.tenant_update_promotions_menu_identifier_settings = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_update_promotions_menu_identifier_settings: (state) => {
   state.tenant_update_promotions_menu_identifier_settings = { status: app_consts.IDLE };
  },
  loading_tenant_update_promotions_menu_identifier_settings: (state) => {
   state.tenant_update_promotions_menu_identifier_settings = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_update_promotions_menu_identifier_settings, fail_tenant_update_promotions_menu_identifier_settings, reset_tenant_update_promotions_menu_identifier_settings, loading_tenant_update_promotions_menu_identifier_settings } = tenant_update_promotions_menu_identifier_settings_Slice.actions;

export default tenant_update_promotions_menu_identifier_settings_Slice.reducer;